// extracted by mini-css-extract-plugin
export default {"banner":"hero_banner__+yQoq","bannerText":"hero_bannerText__twEsH","bouncy":"hero_bouncy__jN9UK"};